module.exports = __webpack_public_path__ + "img/guardian.2b3dd5f6.png";